import React, { ReactElement } from 'react';
import {
  Container,
  Circle,
  LabelWrapper,
  IconWrapper,
  IconContainer,
  StyledSpinner,
} from './styles';

export const IconButton = ({
  onClick,
  label,
  className,
  icon,
  simple,
  iconPosition = 'left',
  type,
  dataCy,
  disabled,
  loading,
}: IconButtonProps) => {
  return label ? (
    <Container
      onClick={onClick}
      className={className}
      $iconPosition={iconPosition}
      type={type || 'button'}
      data-cy={dataCy}
      disabled={disabled}
    >
      <LabelWrapper>{label}</LabelWrapper>
      {simple ? (
        <IconWrapper isLoading={loading}>{icon}</IconWrapper>
      ) : (
        <Circle isLoading={loading}>{icon}</Circle>
      )}
      {loading && <StyledSpinner scale={0.45} />}
    </Container>
  ) : (
    <IconContainer
      type={type || 'button'}
      onClick={onClick}
      className={className}
      data-cy={dataCy}
      disabled={disabled}
    >
      <IconWrapper isLoading={loading}>{icon}</IconWrapper>
      {loading && <StyledSpinner scale={0.45} />}
    </IconContainer>
  );
};

export interface IconButtonProps {
  onClick?: (e: React.MouseEvent) => void;
  label?: string;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  simple?: boolean;
  icon: ReactElement;
  iconPosition?: 'left' | 'right';
  dataCy?: string;
  disabled?: boolean;
  loading?: boolean;
}
